import type { ReactElement } from 'react'
import type { IClusterApp } from '~/types/cluster'

import Modal from '~/components/Modal'
import { ModalBody } from '~/components/Modal/Layout'
import usePreventScroll from '~/hooks/usePreventScroll'

import './styles.scss'

interface Props {
  app?: IClusterApp
  isOpen: boolean
  onClose: VoidFunction
}

const ScreenshotsModal = ({ app, isOpen, onClose }: Props): ReactElement => {
  /** Effects */

  usePreventScroll(isOpen)

  /** Render */

  return (
    <Modal className="app-cluster-screenshots-modal" isOpen={isOpen} onCloseModal={onClose}>
      <ModalBody className="app-cluster-screenshots-body">
        {app?.screenshot_urls?.map((screenshot, idx) => (
          <img alt={`preview ${idx + 1}`} className="screenshot" key={idx} src={screenshot} />
        ))}
      </ModalBody>
    </Modal>
  )
}

export default ScreenshotsModal
